import React, { useRef } from 'react';
import brand1 from "../../Images/amazon.jpg"
import brand2 from "../../Images/walmart.png"
import brand3 from "../../Images/eBay.png"
import brand4 from "../../Images/etsy.png"
import brand5 from "../../Images/shopify.png"
import brand6 from "../../Images/woocommerce.png"
import brand7 from "../../Images/bigcommerce1.png"
import brand8 from "../../Images/Wayfair.png"
import brand9 from "../../Images/wish.png"
import brand10 from "../../Images/Overstock.png"
import brand11 from "../../Images/Target.png"
import brand12 from "../../Images/Macys.png"
import brand13 from "../../Images/ManoMano.png"
import brand14 from "../../Images/Fruugo.png"

export default function Brands({ data }) {


  return (
    <div className="cs_brands cs_style_1">
      <div className="cs_brand" >
          <img src={brand1} alt="brand_image" style={{width:"100px"}}/>
        </div>
        <div className="cs_brand" >
          <img src={brand2} alt="brand_image" style={{width:"130px"}}/>
        </div>
        <div className="cs_brand" >
          <img src={brand3} alt="brand_image" style={{width:"100px"}}/>
        </div>
        <div className="cs_brand" >
          <img src={brand4} alt="brand_image" style={{width:"80px"}}/>
        </div>

        <div className="cs_brand" >
          <img src={brand5} alt="brand_image" style={{width:"110px"}}/>
        </div>

        <div className="cs_brand" >
          <img src={brand6} alt="brand_image" style={{width:"130px"}}/>
        </div>

        <div className="cs_brand" >
          <img src={brand7} alt="brand_image" style={{width:"130px"}}/>
        </div>

        <div className="cs_brand" >
          <img src={brand8} alt="brand_image" style={{width:"130px"}}/>
        </div>

        <div className="cs_brand" >
          <img src={brand9} alt="brand_image" style={{width:"90px"}}/>
        </div>

        
        <div className="cs_brand" >
          <img src={brand10} alt="brand_image" style={{width:"130px"}}/>
        </div>

            
        <div className="cs_brand" >
          <img src={brand11} alt="brand_image" style={{width:"100px"}}/>
        </div>
      
        <div className="cs_brand" >
          <img src={brand12} alt="brand_image" style={{width:"110px"}}/>
        </div>

        <div className="cs_brand" >
          <img src={brand13} alt="brand_image" style={{width:"150px"}}/>
        </div>

        <div className="cs_brand" >
          <img src={brand14} alt="brand_image" style={{width:"90px"}}/>
        </div>
    </div>
  );
}
